module.exports = __webpack_public_path__ + "img/ellipsis-loader.3dd84974.svg";